// src/pages/Privacy.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const C = {
  bg:        "#0d0a05",
  border:    "rgba(212,168,83,0.12)",
  gold:      "#d4a853",
  goldGhost: "var(--bone-text-muted)",
  ivory:     "#e8d5b0",
  ivoryGhost:"rgba(232,213,176,0.35)",
};

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: C.gold, margin: "0 0 10px" }}>{title}</h2>
      <div style={{ height: 1, background: C.border, marginBottom: 14 }} />
      <div style={{ fontFamily: "'Courier Prime', monospace", fontSize: 12, color: C.ivoryGhost, lineHeight: 1.8, letterSpacing: "0.04em" }}>{children}</div>
    </div>
  );
}

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: "100vh", background: C.bg, padding: "40px clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 760, margin: "0 auto" }}>

        <Link to="/" style={{ fontFamily: "'Courier Prime', monospace", fontSize: 11, color: C.gold, textDecoration: "none", letterSpacing: "0.15em" }}>
          {t('legal.backHome')}
        </Link>

        <div style={{ margin: "24px 0 40px" }}>
          <p style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, letterSpacing: "0.38em", color: C.goldGhost, textTransform: "uppercase", marginBottom: 6 }}>
            ✦ {t('legal.eyebrow')} ✦
          </p>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 36, fontWeight: 700, color: C.gold, margin: "0 0 8px" }}>
            {t('legal.privacy.title')}
          </h1>
          <p style={{ fontFamily: "'Courier Prime', monospace", fontSize: 10, color: C.goldGhost, letterSpacing: "0.1em" }}>
            {t('legal.lastUpdated')}
          </p>
          <div style={{ height: 1, background: `linear-gradient(90deg,${C.gold},transparent)`, marginTop: 16, opacity: 0.2 }} />
        </div>

        <Section title={t('legal.privacy.s1.title')}>
          {t('legal.privacy.s1.intro')}<br /><br />
          — <strong style={{ color: C.ivory }}>{t('legal.privacy.s1.d1label')}</strong> {t('legal.privacy.s1.d1')}<br />
          — <strong style={{ color: C.ivory }}>{t('legal.privacy.s1.d2label')}</strong> {t('legal.privacy.s1.d2')}<br />
          — <strong style={{ color: C.ivory }}>{t('legal.privacy.s1.d3label')}</strong> {t('legal.privacy.s1.d3')}
        </Section>

        <Section title={t('legal.privacy.s2.title')}>{t('legal.privacy.s2.body')}</Section>

        <Section title={t('legal.privacy.s3.title')}>
          {t('legal.privacy.s3.intro')}<br /><br />
          — {t('legal.privacy.s3.r1')}<br />
          — {t('legal.privacy.s3.r2')}<br />
          — {t('legal.privacy.s3.r3')}<br />
          <br />{t('legal.privacy.s3.noSell')}
        </Section>

        <Section title={t('legal.privacy.s4.title')}>{t('legal.privacy.s4.body')}</Section>
        <Section title={t('legal.privacy.s5.title')}>{t('legal.privacy.s5.body')}</Section>
        <Section title={t('legal.privacy.s6.title')}>{t('legal.privacy.s6.body')}</Section>
        <Section title={t('legal.privacy.s7.title')}>{t('legal.privacy.s7.body')}</Section>

        <div style={{ fontFamily: "'Courier Prime', monospace", fontSize: 9, color: C.goldGhost, letterSpacing: "0.14em", textAlign: "center", marginTop: 48, paddingTop: 24, borderTop: `1px solid ${C.border}`, display: "flex", gap: 20, justifyContent: "center" }}>
          <Link to="/terms" style={{ color: C.goldGhost, textDecoration: "none" }}>{t('legal.termsLink')}</Link>
          <span>·</span>
          <span>{t('legal.copyright')}</span>
        </div>

      </div>
      <style>{`* { box-sizing: border-box; }`}</style>
    </div>
  );
}
